import { Heading3 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import {
  StyledCaption,
  StyledItem,
  StyledItems,
  StyledSection,
  StyledValue
} from './LocationPreference.styled';
import MethodologyAnchor from './MethodologyAnchor';

const LocationsOffered: React.FC = () => {
  const { t } = useI18n('state-of-the-sector');

  const items = [
    {
      type: 'big',
      value: 87.74617067833698,
      label: t('developers.location.remote')
    },
    {
      type: 'medium',
      value: 35.44857768052516,
      label: t('developers.location.onsite')
    },
    {
      type: 'small',
      value: 10.50328227571116,
      label: t('developers.location.hybrid')
    }
  ];

  return (
    <StyledSection>
      <Heading3>{t('companies.locations.title')}</Heading3>
      <div
        dangerouslySetInnerHTML={{
          __html: t('companies.locations.desc')
        }}
      ></div>
      <StyledItems>
        {items.map((item) => (
          <StyledItem key={item.type}>
            <StyledValue className={item.type}>
              {item.value.toFixed(1)}%
            </StyledValue>
            <StyledCaption>{item.label}</StyledCaption>
          </StyledItem>
        ))}
      </StyledItems>
      <MethodologyAnchor />
    </StyledSection>
  );
};

export default LocationsOffered;
